import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './PermissionDenied.css';

const PermissionDenied = ({ onClose }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleClose = () => {
      if (onClose) {
        onClose();
      }
      navigate('/', { replace: true });
    };

    // Auto-close after 5 seconds and redirect
    const timer = setTimeout(() => {
      handleClose();
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate, onClose]);

  const handleManualClose = () => {
    if (onClose) {
      onClose();
    }
    navigate('/', { replace: true });
  };

  return (
    <div className="permission-denied-overlay">
      <div className="permission-denied-dialog">
        <div className="permission-denied-header">
          <h2>Access Denied</h2>
        </div>
        <div className="permission-denied-content">
          <div className="permission-denied-icon">⊘</div>
          <p>You don't have permission to access this page.</p>
          <p>You will be redirected to the home page.</p>
        </div>
        <div className="permission-denied-actions">
          <button 
            onClick={handleManualClose}
            className="permission-denied-button"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default PermissionDenied;
